import { UISref } from "@uirouter/react";
import PropTypes from "prop-types";
import React from "react";
import i18n from "i18next";

import { SearchResultsTypes } from "../SearchResultsTypes";
import ResultsHighlighter from "./ResultsHighlighter";

const CustomerTile = ({ result, searchQuery, searchField }) => {
  const { shipTo = {}, soldTo = {} } = result;

  return (
    <div className="advanced-search__tile">
      <span className="advanced-search__label">{i18n.t("purchaseOrder.soldTo")}</span>
      <UISref to="CustomerPurchaseOrders" params={{ customerId: soldTo.id, breadcrumbStack: ["CustomerPurchaseOrders"] }}>
        <span className="advanced-search__value --link">
          <ResultsHighlighter
            className="advanced-search__highlight --title"
            searchField={searchField}
            searchQuery={searchQuery}
            fieldName={SearchResultsTypes.soldTo}
            textToHighlight={soldTo.customerName}
          />
        </span>
      </UISref>

      <span className="advanced-search__label">{i18n.t("billsOfLading.ultimateConsignee")}</span>
      <UISref to="CustomerPurchaseOrders" params={{ customerId: shipTo.id, breadcrumbStack: ["CustomerPurchaseOrders"] }}>
        <span className="advanced-search__value --link">
          <ResultsHighlighter
            className="advanced-search__highlight --title"
            searchField={searchField}
            searchQuery={searchQuery}
            fieldName={SearchResultsTypes.shipTo}
            textToHighlight={shipTo.customerName}
          />
        </span>
      </UISref>
    </div>
  );
};

CustomerTile.propTypes = {
  result: PropTypes.object,
  searchField: PropTypes.string,
  searchQuery: PropTypes.string
};

CustomerTile.defaultProps = {
  result: {},
  searchField: "",
  searchQuery: ""
};

export default CustomerTile;



// WEBPACK FOOTER //
// ./src/components/AdvancedSearch/SearchResults/Tiles/CustomerTile.js